import createOnClick from '@iez/lib/create-on-click/'

export default createOnClick
